'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ctx, next) {
        var url, index1, index2, error;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        url = ctx.req.params.url;
                        index1 = url.indexOf('?');

                        if (index1 !== -1) {
                            url = url.substr(0, index1);
                        }
                        index2 = url.indexOf('#');

                        if (index2 !== -1) {
                            url = url.substr(0, index2);
                        }

                        ctx.arms = {
                            begin: new Date(),
                            url: url
                        };
                        _context.prev = 6;
                        _context.next = 9;
                        return next();

                    case 9:
                        _zoroArms2.default.api.success(ctx.arms.url, new Date() - ctx.arms.begin, 'SUCCESS');
                        _context.next = 18;
                        break;

                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context['catch'](6);
                        error = void 0;


                        try {
                            error = ctx.res.error.toString();
                        } catch (e) {
                            error = 'Unhandled error';
                        }

                        _zoroArms2.default.api.error(ctx.arms.url, new Date() - ctx.arms.begin, 'ERROR', error);

                        return _context.abrupt('return', Promise.reject(_context.t0));

                    case 18:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[6, 12]]);
    }));

    return function handler(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = handler;